Apt.fn.make('gallery', {
	/**
	 * Initialize module
	 *
	 * @param {Object} options
	 * @returns {Object}
	 */
	init(options) {
		const scope = this;
		const priv = scope.$private;
		const preload = options.preload;

		scope.conf = Object.assign({
			type: 'image',
			context: {}
		}, options);

		scope.uid = LS.util.uid();

		priv.total = options.app.$get('total_' + scope.conf.type + 's');

		if (priv.total > 1) {
			scope.resume();

			if (preload || options.value) {
				priv.fetch(options.value || 'next', preload);
			}
		}

		$('img', options.delegate)
			.first()
			.on('error', () => {
				priv.log();
			});

		return scope;
	},

	/**
	 * Set gallery position
	 *
	 * @param {Number|String} value
	 */
	move(value) {
		this.$private.fetch(value);
	},

	/**
	 * Pause events
	 */
	pause() {
		const uid = this.uid;

		$.fetch.abort(uid);
		$.events.reset(uid);
	},

	/**
	 * Resume events
	 */
	resume() {
		const scope = this;
		const conf = scope.conf;

		if (conf.bind) {
			$.events.on('$next, $prev', 'mousedown', (e, el) => {
				if (e.button === 2) {
					return;
				}

				scope.move(el.dataset.action || 'prev');
			}, {
				delegate: conf.delegate,
				namespace: scope.uid
			});

			if (conf.large) {
				$(document).on('keydown', e => {
					const key = e.keyCode;

					if (
						key === 37 ||
						key === 39
					) {
						const active = document.activeElement;

						if (active && active.form) {
							return;
						}

						scope.move(
							key === 39 ?
								'next' : 'prev'
						);
					}
				}, {
					namespace: scope.uid
				});
			}
		}
	},

	/**
	 * Destroy module
	 *
	 * @private
	 */
	_destruct() {
		const scope = this;

		scope.$private.state(true);

		scope.pause();

		scope.conf.app = null;
	}
}, {
	/**
	 * Process gallery request
	 *
	 * @param {Number|String} value
	 * @param {Boolean} [preload=false]
	 */
	fetch(value, preload) {
		const scope = this;
		const pub = scope.$public;
		const conf = pub.conf;

		if (! conf.app) {
			return;
		}

		if (conf.type === 'video') {
			if (preload) {
				return;
			}

			scope.set(value);

			return;
		}

		if (scope.fetched && ! preload) {
			scope.load(value);

			return;
		}

		if (conf.large) {
			scope.fetched = true;

			scope.process(conf, conf.data);
			scope.load(value, preload);

			return;
		}

		if (preload) {
			scope.loading = true;
		} else {
			scope.state();

			if (scope.loading) {
				scope.loading = 'load';

				return;
			}

			scope.loading = true;
		}

		LS.api.get('listings/' + conf.id + '/thumbnails', {
			namespace: pub.uid,
			proxy: true,
			success: data => {
				if (! conf.app) {
					return;
				}

				scope.fetched = true;

				conf.app.$pause();

				scope.process(conf, data);

				conf.app.$resume();

				if (! preload || scope.loading === 'load') {
					scope.load(value);
				}
			},
			error: () => {
				if (conf.app && ! preload) {
					clearTimeout(scope.loader);

					conf.app.$drop('loading');
				}
			},
			complete: () => {
				delete scope.loading;
			}
		});
	},

	/**
	 * Set loading state
	 *
	 * @param {Boolean} [end=false]
	 */
	state(end) {
		const scope = this;

		if (end) {
			clearTimeout(scope.loader);

			return;
		}

		scope.loader = setTimeout(() => {
			scope.$public.conf.app.$set('loading', true);
		}, 200);
	},

	/**
	 * Load gallery images
	 *
	 * @param {Number|String} value
	 * @param {Boolean|Number} [preload=false]
	 */
	load(value, preload) {
		const scope = this;
		const pub = scope.$public;
		const conf = pub.conf;
		const images = conf.app.$get('images');
		const numeric = ! preload && Number.isInteger(value);

		let index;
		let targets;

		if (preload) {
			if (preload === true) {
				if (value === 'next') {
					index = 1;
				} else {
					index = scope.index(value);

					index = index ?
						index - 1 :
						scope.total - 1;
				}
			} else {
				index = preload + (value === 'next' ? 4 : -4);
			}

			if (! images[index]) {
				return;
			}
		} else if (numeric) {
			index = value - 1;
		} else {
			index = scope.index(value) - 1;
		}

		try {
			if (images[index].fetched) {
				if (! preload) {
					scope.set(value);

					if (index % 4) {
						scope.load(value, index);
					}
				}

				return;
			}
		} catch (e) {
			scope.log(e.message);

			return;
		}

		if (numeric) {
			targets = [
				images[index].path
			];

			images[index].fetched = true;
		} else {
			const range = index + (value === 'next' ? 4 : -4);
			const min = Math.min(index, range);
			const max = Math.max(index + 1, range);

			targets = LS.util.pluck(
				images.slice(min, max),
				conf.large && $.screen.size() === 1 ?
					'small' : 'path'
			);

			if (value === 'prev') {
				targets.reverse();
			}

			images.forEach((image, i) => {
				image.position = i + 1;

				if (i >= min && i < max) {
					image.fetched = true;
				}
			});
		}

		if (! targets.length) {
			return;
		}

		if (! preload && ! scope.loading) {
			scope.state(true);
			scope.state();
		}

		$.assets.load({
			img: index === 1 ?
				targets.slice(0, 1) :
				targets,
			success: () => {
				if (! conf.app) {
					return;
				}

				conf.app.$set('images', images);

				if (index === 1 && targets.length > 1) {
					$.assets.load({
						img: targets.slice(1)
					});
				}

				if (! preload) {
					scope.state(true);

					conf.app.$drop('loading');

					scope.set(value);

					if (! numeric) {
						scope.load(value, index);
					}
				}
			}
		});
	},

	/**
	 * Process assets
	 *
	 * @param {Object} conf
	 * @param {Object} data
	 */
	process(conf, data) {
		const scope = this;

		if (scope.processed) {
			return;
		}

		conf.app.$set('images', this.transform(data));

		scope.processed = true;
	},

	/**
	 * Transform response
	 *
	 * @param {Object} data
	 * @returns {Array}
	 */
	transform(data) {
		const conf = this.$public.conf;
		const large = conf.large;

		try {
			return data.images.map((image, i) => {
				const ratio = image.width / image.height;
				const obj = Object.assign(image, {
					position: i + 1,
					path: $.get('cdnUrl') + '/listings/' + data.hash + '/' +
						(large ? 'large' : 'small') + '/' + image.key + '.jpg',
					fetched: i === 0,
					cover: ratio > 1 && ratio < 2
				});

				if (large) {
					obj.small = obj.path.replace('/large/', '/small/');
				} else if (! i) {
					obj.cover = true;
				}

				return obj;
			});
		} catch (e) {
			this.log(e.message);
		}
	},

	/**
	 * Calculate index
	 *
	 * @param {String} value
	 * @returns {Number}
	 */
	index(value) {
		const scope = this;
		const conf = scope.$public.conf;

		let index = conf.app.$get('active_' + conf.type);

		if (value === 'next') {
			index++;

			return index > scope.total ?
				1 : index;
		}

		index--;

		return index < 1 ?
			scope.total : index;
	},

	/**
	 * Set position
	 *
	 * @param {Number|String} [value]
	 */
	set(value) {
		const scope = this;
		const conf = scope.$public.conf;
		const position = Number.isInteger(value) ?
			value : scope.index(value);

		$.exec(conf.move, {
			args: [position, scope.total]
		});

		conf.app.$set(`active_${conf.type}`, position);
	},

	/**
	 * Log error
	 *
	 * @param {String} [cause]
	 */
	log(cause) {
		const id = this.$public.conf.id;

		LS.error.report('GalleryError', cause, {
			listing_id: id
		});
	}
});